module.exports = __webpack_public_path__ + "img/Menu-10.323af04e.png";